import type { IRootState } from '../types';
import { createSelector } from 'reselect';
import { partition, sortBy } from 'lodash';

import { Event, EventStatus } from '@wix/ambassador-events-v1-event/types';

export const selectEvents = (state: IRootState) => state.events.events;

export const selectUpcomingAndPastEvents = createSelector(
  selectEvents,
  (events) => {
    const [upcoming, past] = splitByUpcomingAndPast(events);

    return [
      upcoming,
      sortBy(past, ['event', 'scheduling', 'config', 'startDate']),
    ];
  },
);

function splitByUpcomingAndPast(
  events: Event[],
): [upcoming: Event[], past: Event[]] {
  const [upcoming, past] = partition(
    events,
    (event) =>
      event.status === EventStatus.STARTED ||
      event.status === EventStatus.SCHEDULED,
  );

  return [upcoming, past];
}
